module.exports = __webpack_public_path__ + "img/check-circle-gray.f79b7acf.svg";